.container {
  flex: 1;
  display: flex;
  overflow: hidden;
}
